import { Box, Button, Grid, Modal } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import StartEndDatepicker from '../../../StartEndDatepicker/StartEndDatepicker';
import './SupportSheetPeriod.scss';

interface SupportSheetPeriodProp {
    title: string,
    selectedDate: string,
    onChange: (date: string) => void,
    className?: string,
}

const SupportSheetPeriod: React.FunctionComponent<SupportSheetPeriodProp> = (props) => {
    const dispatch = useDispatch();
    const [showPeriodInput, setShowPeriodInput] = useState<boolean>(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "800px",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            <Button
                variant='contained'
                className='support-sheet-period-button'
                onClick={() => {
                    setShowPeriodInput(true);
                }}
            ><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
            <Modal
                open={showPeriodInput}
                onClose={() => {
                    setShowPeriodInput(false);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item xs={10}>
                            <StartEndDatepicker
                                startDateLabel={props.title}
                                useQuickEndDateInput={false}
                                className='cargo-input-component'
                                onStartDateChange={(date: string) => {
                                    props.onChange(date);
                                }}
                                startDateValue={props.selectedDate.toUpperCase()}
                                useSingleMode={true}
                            >
                            </StartEndDatepicker>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                onClick={() => {
                                    setShowPeriodInput(false);
                                }}
                                variant="outlined"
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
};

export default SupportSheetPeriod;